import React from 'react'
import useBreakpoint from '../hooks/useBreakpoint'

export default function renderBelowBreakpoint<P>(
  breakpointName: string,
  InnerComponent: React.ComponentType<P>
) {
  const WrapperComponent: React.FC<P> = props => {
    const isLargerThanBreakpoint = useBreakpoint(breakpointName)

    if (isLargerThanBreakpoint) {
      return null
    }

    return <InnerComponent {...props} />
  }

  return WrapperComponent
}
